import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { INTERNAL_API_ROOT, ACCEPT_JSON_HEADERS } from '../../config/api'
import { errorNotification } from '../application/notifications'

// TYPES AND ACTIONS
export const GET_ORGANIZATION_TEMPLATES_REQUEST = 'GET_ORGANIZATION_TEMPLATES_REQUEST'
export const GET_ORGANIZATION_TEMPLATES_SUCCESS = 'GET_ORGANIZATION_TEMPLATES_SUCCESS'
export const GET_ORGANIZATION_TEMPLATES_FAILURE = 'GET_ORGANIZATION_TEMPLATES_FAILURE'
export const CLONE_ORGANIZATION_REQUEST = 'CLONE_ORGANIZATION_REQUEST'
export const CLONE_ORGANIZATION_SUCCESS = 'CLONE_ORGANIZATION_SUCCESS'
export const CLONE_ORGANIZATION_FAILURE = 'CLONE_ORGANIZATION_FAILURE'
export const SET_IS_SAVING = 'SET_IS_SAVING'

export const getOrganizationTemplatesResults = () => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/templates`,
      types: [
        GET_ORGANIZATION_TEMPLATES_REQUEST,
        GET_ORGANIZATION_TEMPLATES_SUCCESS,
        GET_ORGANIZATION_TEMPLATES_FAILURE,
      ],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error retrieving templates`,
          dismissInSeconds: 10,
        })
      )
    }
  })
}

export const cloneOrganization =
  (organizationId, name, websiteUrl, phoneNumber, subdomain) => dispatch => {
    dispatch({ type: SET_IS_SAVING, payload: { isSaving: true } })
    dispatch({
      [CALL_INTERNAL_API]: {
        method: 'POST',
        endpoint: `${INTERNAL_API_ROOT}/admin/organizations/clone/${organizationId}`,
        types: [CLONE_ORGANIZATION_REQUEST, CLONE_ORGANIZATION_SUCCESS, CLONE_ORGANIZATION_FAILURE],
        headers: {
          ...ACCEPT_JSON_HEADERS,
        },
        body: JSON.stringify({ name, websiteUrl, phoneNumber, subdomain }),
      },
    }).then(response => {
      dispatch({ type: SET_IS_SAVING, payload: { isSaving: false } })
      if (response.error) {
        dispatch(
          errorNotification({
            body: response.payload.response.messages[0],
            dismissInSeconds: 10,
          })
        )
      } else {
        window.location.replace(`https://${response.payload.domain}/login`)
      }
    })
  }

// SELECTORS
const selectClone = state => state.submittable.clone
export const selectOrganizationTemplates = state => selectClone(state).organizationTemplates
export const selectIsSaving = state => selectClone(state).isSaving

// STATE
const INITIAL_STATE = {
  organizationTemplates: [],
  isSaving: false,
}

// REDUCERS
const clone = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_ORGANIZATION_TEMPLATES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organizationTemplates: [...newPayload],
    }),
    [SET_IS_SAVING]: (currentState, newPayload) => ({
      ...currentState,
      isSaving: newPayload.isSaving,
    }),
  }[type]?.(state, payload) || state)

export default clone
